import { IRankingDiscipline } from "@studyportals/domain-client";

interface Projection {
	getOrganisationMetaRankingPositionsByDiscipline: () => IRankingDiscipline[] | null
}

export class Deployment {
	public static isLatestDomainApiResponse(projection: Projection): boolean {
		return (
			typeof projection['getOrganisationMetaRankingPositionsByDiscipline'] === 'function'
		);
	}
}
